import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { object, string, ObjectSchema } from 'yup';
import { ISubscriptionEmail } from '../../alertSubscription.interface';

export const useAddEmailFormSchema = (): ObjectSchema<ISubscriptionEmail> => {
  const { t } = useTranslation();

  return useMemo(() => {
    return object({
      email: string()
        .trim()
        .label(t('text:entity.user.email.label'))
        .email()
        .required(),
    });
  }, [t]);
};
